import request from '../utils/csrf-superagent'; // enhanced superagent to handle jwt-csrf tokens
import config from '../config';
import actions from '../actions/actions';
import companyLocationActions from '../actions/companyLocation';

function submitCompanyLocation(store, action) {
    const companyLocation = action.payload.companyLocation;
    request.post(`/${config.url_prefix}/api/companyLocation`)
        .send({
            data: companyLocation
        })
        .set('x-homeaway-site', store.getState().system.siteName)
        .end((error, response) => {
            if (error) {
                const errorKey = 'internal.server.error';
                store.dispatch(actions.enableLoadOverLay(false));
                store.dispatch(companyLocationActions.alertError(errorKey));
            } else if (response.statusCode === 204) {
                store.dispatch(actions.changeAppState('CURRENCY_DETAILS'));
            } else {
                const errorKey = 'ipmob.error.process.request';
                store.dispatch(actions.enableLoadOverLay(false));
                store.dispatch(companyLocationActions.alertError(errorKey));
            }
        });
}

export default submitCompanyLocation;
